module.exports = __webpack_public_path__ + "img/zero 1@2x.407b8bd5.png";